import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CredentialVerification from './pages/credential-verification';
import Dashboard from './pages/dashboard';
import PrivacySettings from './pages/privacy-settings';
import DigitalWallet from './pages/digital-wallet';
import CredentialIssuance from './pages/credential-issuance';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<CredentialIssuance />} />
        <Route path="/credential-verification" element={<CredentialVerification />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/privacy-settings" element={<PrivacySettings />} />
        <Route path="/digital-wallet" element={<DigitalWallet />} />
        <Route path="/credential-issuance" element={<CredentialIssuance />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
